import { render, staticRenderFns } from "./ksAlert.vue?vue&type=template&id=3702a7ab"
import script from "./ksAlert.vue?vue&type=script&lang=js"
export * from "./ksAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports